import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchEmployeeSupervisor } from 'app/actions/BookmarkActions';
import { getEmployeeSupervisor } from 'app/reducers';
import isEmpty from 'app/utils/IsEmpty';

export default function SupervisorContainer(props) {
    let dispatch = useDispatch();
    let supervisor = useSelector(getEmployeeSupervisor);

    useEffect(() => {
        if (isEmpty(supervisor)) fetchSupervisorAction();
    }, []);
    const fetchSupervisorAction = () => dispatch(fetchEmployeeSupervisor());
    return (props.children({ supervisor }));
}